<template>
  <el-form
    ref="platformLineForm"
    class="search-form"
    :inline="true"
    :model="form"
    :label-width="labelWidth"
  >
    <el-row :class="openMore ? 'search-bar-content-show' : 'search-bar-content-close'">
      <el-col :span="6">
        <el-form-item label="站点名称">
          <el-input
            v-model="form.stationNameLike"
            placeholder="请输入站点名称"
            @keyup.enter.native="fetchData"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="租户名称">
          <el-input
            v-model="form.tenantNameLike"
            placeholder="请输入租户名称"
            @keyup.enter.native="fetchData"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="客户名称">
          <el-input
            v-model="form.customerNameLike"
            placeholder="请输入客户名称"
            @keyup.enter.native="fetchData"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="业态类型">
          <el-select v-model="form.type">
            <el-option
              v-for="item in formatOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="状态">
          <el-select v-model="form.status">
            <el-option
              v-for="item in stateOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="站点类型">
          <el-select v-model="form.bizType">
            <el-option
              v-for="item in siteOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <div class="search-btns">
          <div class="moreData" @click="openMore = !openMore">
            {{ !openMore ? "展开筛选" : "收起筛选" }}
            <el-icon :class="openMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
          </div>
          <div class="form-btns">
            <el-button
              class="form-btn"
              type="primary"
              @click.native.prevent="searchData"
            >
              查 询
            </el-button>
            <el-button class="form-btn" @click.native.prevent="resetData">
              重 置
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { processingSelectData } from '@/utils/index';
import { SiteTypesInfo, SiteStatus, SiteCommercialtype } from '../const';

export default {
  name: 'ListFilter',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      labelWidth: '128px',
      openMore: false,
    };
  },
  computed: {
    formatOption() {
      return [
        { value: null, label: '全部' },
        ...processingSelectData(SiteCommercialtype),
      ];
    },
    stateOption() {
      return [
        { value: null, label: '全部' },
        ...processingSelectData(SiteStatus),
      ];
    },
    siteOption() {
      return [
        { value: null, label: '全部' },
        ...processingSelectData(SiteTypesInfo),
      ];
    },
  },
  created() {
  },
  methods: {
    fetchData() {
      this.$emit('searchData', { ...this.form });
    },
    searchData() {
      this.$emit('searchData', { ...this.form });
    },

    resetData() {
      this.$emit('resetData');
    },
  },
};
</script>
<style lang="scss" scoped>

.search-btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .moreData {
    font-size: 12px;
    color: #606266;
    margin-right: 28px;
    &:hover {
      cursor: pointer;
    }
    [class*=" el-icon-"],
    [class^="el-icon-"] {
      color: #059E84 !important;
      font-family: "element-icons" !important;
    }
  }
}
.search-form ::v-deep {
  .el-col {
    margin: 12px 0;
    .el-form-item {
      width: 100%;
      display: flex;
      margin: 0;
      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
      }
      .el-form-item__content {
        width: calc(100% - 128px);
        .el-select,
        .el-date-editor  {
          width: 100%;
        }
      }
    }
  }
}
.search-bar-content-close::v-deep {
  .el-col {
    display: none !important;
  }
  .el-col:nth-child(1) {
    display: block !important;
  }
  .el-col:nth-child(2) {
    display: block !important;
  }
  .el-col:nth-child(3) {
    display: block !important;
  }
  .el-col:nth-last-child(1) {
    float: right !important;
    display: block !important;
  }
}
.search-bar-content-show::v-deep {
  .el-col:nth-last-child(1) {
    float: right !important;
  }
}
</style>
